var _g, _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewChatIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_53_5097)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 40,
    height: 40,
    rx: 16,
    fill: "url(#paint0_linear_53_5097)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 40,
    height: 40,
    rx: 16,
    fill: "#1D2020",
    fillOpacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 24C31.5 24.1658 31.4342 24.3247 31.3169 24.4419C31.1997 24.5592 31.0408 24.625 30.875 24.625H24.625V30.875C24.625 31.0408 24.5592 31.1997 24.4419 31.3169C24.3247 31.4342 24.1658 31.5 24 31.5C23.8342 31.5 23.6753 31.4342 23.5581 31.3169C23.4408 31.1997 23.375 31.0408 23.375 30.875V24.625H17.125C16.9592 24.625 16.8003 24.5592 16.6831 24.4419C16.5658 24.3247 16.5 24.1658 16.5 24C16.5 23.8342 16.5658 23.6753 16.6831 23.5581C16.8003 23.4408 16.9592 23.375 17.125 23.375H23.375V17.125C23.375 16.9592 23.4408 16.8003 23.5581 16.6831C23.6753 16.5658 23.8342 16.5 24 16.5C24.1658 16.5 24.3247 16.5658 24.4419 16.6831C24.5592 16.8003 24.625 16.9592 24.625 17.125V23.375H30.875C31.0408 23.375 31.1997 23.4408 31.3169 23.5581C31.4342 23.6753 31.5 23.8342 31.5 24Z",
    fill: "#E4E6E7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_53_5097",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_53_5097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_53_5097",
    x1: 4,
    y1: 24,
    x2: 44,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#005CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D00FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChatIconDark);
export default __webpack_public_path__ + "static/media/new_chat_icon_dark.9c6206632d201268f20cc5a9882c1e06.svg";
export { ForwardRef as ReactComponent };